import * as ActionTypes from 'constants';

const copy = (json) => (JSON.parse(JSON.stringify(json)));

export const fields = (state = {
  //Loading vars
  fetching_fields : false,
}, action) => {
  const {type, payload} = action;
  let copy_state,
      fields;

  switch(type) {
    case ActionTypes.FETCH_FIELDS:
      return {...state, fetching_fields : true};
    case ActionTypes.FETCH_FIELDS_SUCCESS: case ActionTypes.FETCH_FIELDS_FAILED:
      return {...state, fetching_fields : false};
    case ActionTypes.ADD_FIELD:
      copy_state = copy(state);
      let found_field_index = -1;
      let found_field = (copy_state[payload.field.entity] || []).find(({_id}, index) => {
        let truthy = (_id == payload.field._id);
        if(truthy) {
          found_field_index = index;
        }
        return truthy;
      });

      if(found_field) {
        copy_state[payload.field.entity][found_field_index] = payload.field;
        return copy_state;
      }

      fields = [
        ...(copy_state[payload.field.entity] || []),
        payload.field
      ];

      copy_state[payload.field.entity] = fields;
      return copy_state;
      break;
    case ActionTypes.ADD_FIELDS:
      copy_state = copy(state);
      if(payload.fields.length > 0) {
        copy_state[payload.fields[0].entity] = payload.fields;
      }
      return copy_state;
      break;
    case ActionTypes.REMOVE_FIELD:
      copy_state = copy(state);
      fields = [
        ...(copy_state[payload.field.entity] || [])
          .filter(({_id}) => (_id != payload.field._id))
      ];
      copy_state[payload.field.entity] = fields;
      return copy_state;
      break;
    case ActionTypes.CLEAR_FIELDS:
      copy_state = copy(state);
      copy_state[action.payload.entity] = [];
      return copy_state;
      break;
    default:
      return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/common/reducers/fields.js